import { render, staticRenderFns } from "./LawComponent.vue?vue&type=template&id=33ec0bba&scoped=true&"
var script = {}
import style0 from "./LawComponent.vue?vue&type=style&index=0&id=33ec0bba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ec0bba",
  null
  
)

export default component.exports